var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('epi-offcanvas',{attrs:{"opening-event-name":_vm.openingEventName,"title":"알림 전송"},scopedSlots:_vm._u([{key:"body",fn:function(){return undefined},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }